export const IMAGE_SIZE = {
  MAX_WIDTH: 600,
  MAX_HEIGHT: 600,
  FORMAT: 'PNG',
  QUALITY: 100,
  ROTATION: 0,
  OUTPUT_TYPE: 'base64',
};